<template>
  <nav role="navigation" aria-label="Pagination Navigation" class="flex items-center justify-between">
    <div class="flex justify-between flex-1 sm:hidden">
      <Link v-bind:href="pagination.prev_page_url" as="button" class="relative inline-flex items-center px-4 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 cursor-default leading-5 rounded-md">
        &laquo; Previous
      </Link>
      <Link v-bind:href="pagination.next_page_url" as="button" class="relative inline-flex items-center px-4 py-2 ml-3 text-sm font-medium text-gray-700 bg-white border border-gray-300 leading-5 rounded-md hover:text-gray-500 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150">
        Next &raquo;
      </Link>
    </div>

    <div class="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between ">
      <div>
        <p class="text-sm text-gray-700 leading-5 space-x-1">
          <span>Showing</span>
          <span class="font-medium">{{ pagination.from }}</span>
          <span>to</span>
          <span class="font-medium">{{ pagination.to }}</span>
          <span>of</span>
          <span class="font-medium">{{ pagination.total }}</span>
          <span>results</span>
        </p>
      </div>

      <div>
        <span class="relative z-0 inline-flex rounded-md shadow-sm">

          <!-- previous -->
          <Link v-bind:href="pagination.prev_page_url" as="button" class="relative inline-flex items-center px-2 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-l-md leading-5 hover:text-gray-400 focus:z-10 focus:outline-none transition ease-in-out duration-150" aria-hidden="true">
            <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clip-rule="evenodd"></path>
            </svg>
          </Link>

          <!-- pages -->
          <template v-for="link in pagination.links.slice(1, -1)">
            <template v-if="link.active">
              <span class="relative inline-flex items-center px-4 py-2 -ml-px text-sm font-medium text-gray-500 bg-white border border-gray-300 cursor-default leading-5">
                {{ link.label }}
              </span>
            </template>
            <template v-else>
              <span>
                <Link v-bind:href="link.url" as="button" class="relative inline-flex items-center px-4 py-2 -ml-px text-sm font-medium text-gray-700 bg-white border border-gray-300 leading-5 hover:text-gray-500 focus:z-10 focus:outline-none transition ease-in-out duration-150">
                  {{ link.label }}
                </Link>
              </span>
            </template>
          </template>

          <!-- next -->
          <Link v-bind:href="pagination.next_page_url" as="button" class="relative inline-flex items-center px-2 py-2 -ml-px text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-r-md leading-5 hover:text-gray-400 focus:z-10 focus:outline-none transition ease-in-out duration-150">
            <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"></path>
            </svg>
          </Link>

        </span>
      </div>
    </div>
  </nav>
</template>

<script setup>
import { Link } from "@inertiajs/vue3";

const { pagination } = defineProps({
  pagination: {
    type: Object,
    required: true,
  }
});
</script>
